/* WellNova catalog — search, price filtering, URL state, mobile sheet.

   Neither the need/category taxonomy nor the price band is handled in JS any
   more: both are real URLs the server resolves. The taxonomy levels are
   collections; price rides Shopify's native storefront filter
   (filter.v.price.gte / filter.v.price.lte). That is what makes a price band
   cover the whole catalog instead of the 48 cards on the current page, and it
   fixes the pager and the product count at the same time.

   Only the search box still runs on the client and stays scoped to the current
   page. Sort is server-side via Shopify's ?sort_by; this only mirrors it back
   into the select. */
(function(){
  var grid = document.getElementById('kn-grid');
  if (!grid) return;

  var cards   = Array.prototype.slice.call(grid.querySelectorAll('.kn-card'));
  var qInput  = document.getElementById('kn-q');
  var sortSel = document.getElementById('kn-sort');
  var countEl = document.getElementById('kn-count');
  var emptyEl = document.getElementById('kn-empty');
  var fcount  = document.getElementById('kn-fcount');
  var sheetCount = document.getElementById('kn-sheet-count');

  var PRICE_KEYS = ['filter.v.price.gte', 'filter.v.price.lte'];

  /* The server renders paginate.items here, so this already counts every page
     of the active price band — not just the cards in this grid. */
  var total = countEl ? parseInt(countEl.textContent, 10) : NaN;
  if (isNaN(total) || total < cards.length) total = cards.length;

  var state = { q:'' };

  function params(){ return new URLSearchParams(location.search); }

  function priceActive(){
    var p = params();
    return PRICE_KEYS.some(function(k){ return p.has(k); });
  }

  /* gte+lte is the middle band, gte alone the top, lte alone the bottom —
     the same three shapes Liquid writes into data-url. */
  function bandFromURL(){
    var p = params();
    var gte = p.get('filter.v.price.gte');
    var lte = p.get('filter.v.price.lte');
    if (gte && lte) return '50to100';
    if (gte) return 'over100';
    if (lte) return 'under50';
    return '';
  }

  function cleanURL(){
    var p = params();
    PRICE_KEYS.forEach(function(k){ p.delete(k); });
    p.delete('q');
    p.delete('page');
    var qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function readURL(){
    state.q = params().get('q') || '';
  }

  function writeURL(){
    var p = params();
    state.q ? p.set('q', state.q) : p.delete('q');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function syncControls(){
    if (qInput && qInput.value !== state.q) qInput.value = state.q;
    var band = bandFromURL();
    document.querySelectorAll('input[data-price]').forEach(function(c){
      c.checked = c.getAttribute('data-price') === band;
    });
    var active = (band ? 1 : 0) + (state.q ? 1 : 0);
    if (fcount){
      fcount.textContent = active;
      fcount.hidden = active === 0;
    }
  }

  function apply(){
    var q = state.q.trim().toLowerCase();
    var shown = 0;

    cards.forEach(function(card){
      var name = card.getAttribute('data-name') || '';
      var ok = !q || name.indexOf(q) !== -1;
      card.hidden = !ok;
      if (ok) shown++;
    });

    /* Not searching → the server's figure, which spans every page of the band.
       Searching → what actually matched on this page. */
    var n = q ? shown : total;
    if (countEl) countEl.textContent = n + ' product' + (n === 1 ? '' : 's');
    if (sheetCount) sheetCount.textContent = n;
    if (emptyEl) emptyEl.classList.toggle('is-on', shown === 0);
    grid.hidden = shown === 0;

    syncControls();
    writeURL();
  }

  /* Delegated, so the rail and the mobile sheet share one handler. The rail's
     "clear" is an <a> back to /collections/all once a need is open — only the
     root-level <button> version reaches this. */
  document.addEventListener('click', function(e){
    var clr = e.target.closest('button.kn-clear') || e.target.closest('.kn-clear-all');
    if (!clr) return;
    /* A price band is a server-side URL, so dropping it means reloading. With
       nothing but a search term there is nothing to go back to the server for. */
    if (priceActive()){
      location.assign(clr.getAttribute('data-clear-url') || cleanURL());
      return;
    }
    state.q = '';
    apply();
  });

  document.addEventListener('change', function(e){
    var pr = e.target.closest('input[data-price]');
    if (!pr) return;
    /* Ticking a band replaces whichever was active — gte/lte describe one
       range, so the three bands are mutually exclusive by construction. */
    location.assign(pr.checked ? (pr.getAttribute('data-url') || cleanURL()) : cleanURL());
  });

  if (qInput){
    var t;
    qInput.addEventListener('input', function(){
      clearTimeout(t);
      t = setTimeout(function(){ state.q = qInput.value; apply(); }, 180);
    });
  }

  if (sortSel){
    sortSel.addEventListener('change', function(){
      var p = params();
      sortSel.value ? p.set('sort_by', sortSel.value) : p.delete('sort_by');
      p.delete('page');
      var qs = p.toString();
      location.assign(location.pathname + (qs ? '?' + qs : ''));
    });
  }

  /* mobile filter sheet */
  var openBtn  = document.getElementById('kn-filter-open');
  var sheet    = document.getElementById('kn-sheet');
  var scrim    = document.getElementById('kn-scrim');
  var closeBtn = document.getElementById('kn-sheet-close');
  var applyBtn = document.getElementById('kn-sheet-apply');
  var lastFocus = null;

  function openSheet(){
    lastFocus = document.activeElement;
    sheet.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function(){
      sheet.classList.add('is-on'); scrim.classList.add('is-on');
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeSheet(){
    sheet.classList.remove('is-on'); scrim.classList.remove('is-on');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function(){ sheet.hidden = true; scrim.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }
  if (openBtn)  openBtn.addEventListener('click', openSheet);
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);
  if (scrim)    scrim.addEventListener('click', closeSheet);
  if (applyBtn) applyBtn.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  readURL();
  apply();
})();
